module.exports = __webpack_public_path__ + "img/default-profile-icon.da84b919.svg";